import IRegimeDeCasamentoParaSelect from '../../interfaces/IRegimeDeCasamentoParaSelect';
import IRegimeDeCasamento from '../../interfaces/IRegimeDeCasamento';

export const mapearRegimeDeCasamentoParaSelect = (regimesDeCasamento: IRegimeDeCasamento[]): IRegimeDeCasamentoParaSelect[] =>
  regimesDeCasamento.map(({ id, nome }) => ({
    value: id,
    label: nome
  }));